import gql from 'graphql-tag'
import cl from './client'

var client = cl.get()
function get_image_data (id) {
  return client
    .query({
      //prettier-ignore
      query: gql`query($id: ID!){ imageData(id: $id) }`,
      variables: { id: id }
    })
    .then(res => res.data.imageData)
}

export default {
  // User Stats
  get_tests: batchid =>
    client
      .query({
        // prettier-ignore
        query: gql`query($batchid: ID!){
          batch(id: $batchid){
            tests{
              id, numSequence, numSubmittedSequence
              assignedTo{ id, name }
            }
          }
        }`,
        variables: { batchid: batchid }
      })
      .then(res => (res.data.batch ? res.data.batch.tests : [])),
  get_test_detail: testid =>
    client
      .query({
        // prettier-ignore
        query: gql`query($testid: ID!){
          test(id: $testid){
            id
            sequences{
              id, type, answer, submitted
              question{
                key, type, layoutType, content, contentImage, answers, answerImages, templateId
                solution{ data, type }
              }
              refQuestion{
                key, type, layoutType, content, answers,
                solution{ data, type }
              }
            }
          }
        }`,
        variables: { testid: testid }
      })
      .then(res => (res.data ? res.data.test : null)),
  add_images_to_question: async q => {
    var r = []
    if (q.contentImage) {
      r.push(get_image_data(q.contentImage))
    }
    if (q.answerImages) {
      for (var j = 0; j < q.answerImages.length; ++j) {
        r.push(get_image_data(q.answerImages[j]))
      }
    }
    if (r.length == 0) {
      return q
    }
    r = await Promise.all(r)
    var k = 0
    if (q.contentImage) {
      q.contentImageData = r[k]
      k++
    }
    if (q.answerImages) {
      q.answerImagesData = []
      for (var j = 0; j < q.answerImages.length; ++j) {
        q.answerImagesData.push(r[k])
        k++
      }
    }
    return q
  }
}
